import React from 'react';
import './home-playlists-carousel.scss';
import bdReq from '../../../@packages/@bd-uikit-web/js-helpers/bdReq';
import PlaylistArtwork from '../PlaylistArtwork';
import { sendIndexes, getMuteFlag, getQualityFlag, getOffset, storeOffset } from '../../pages/utils.js';
import store from 'store';

export default class HomePlaylistsCarousel extends React.Component {
  constructor(props) {
    super(props);

    let { userPlaylist } = props;
    const currentPlaylist = props.userPlaylist ? props.userPlaylist[parseInt(props.userPlaylist.length / 2)] : 0;
    const playlistIndex = parseInt(props.userPlaylist.length / 2);
    let name = userPlaylist ? userPlaylist.map((item, id) => item.content ? item.content.name : item.name) : null;
    let id = '';

    this.state = {
      currentPlaylist,
      currentArtwork: currentPlaylist ? currentPlaylist.content ? parseInt(currentPlaylist.content.artworks.length / 2) : parseInt(currentPlaylist.artworks.length / 2) : 0,
      name,
      current: name ? parseInt(name.length / 2) : 0,
      playlistIndex,
      show: false,
      playlist: props.userPlaylist,
      artworks: currentPlaylist ? currentPlaylist.content ? currentPlaylist.content.artworks : currentPlaylist.artworks : [],
      showlist: false,
      transition: false,
      artNo: 3,
      mute: "false",
      highquality: ""
    }

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.selectTab = this.selectTab.bind(this);
    this.handlePlaylist = this.handlePlaylist.bind(this);
    this.offset = getOffset() || 0;
  }

  componentWillMount() {
    this.setList();
    this.checkQuality();
    this.setState({
      mute: getMuteFlag() || "false",
    })
  }

  componentWillUnmount() {
    storeOffset(this.offset);
  }

  componentDidUpdate() {
    this.setList();
  }

  checkQuality() {
    if (getQualityFlag()) {
      this.setState({
        highquality: "4k"
      })
    } else {
      this.setState({
        highquality: "high"
      })
    }
  }

  setList() {
    let { currentArtwork, artworks } = this.state;
    if (currentArtwork == artworks.length - 1 || currentArtwork == artworks.length - 2) {
      var newArray = this.state.artworks.slice();
      for (let i = 0; i < artworks.length; i++) {
        newArray.push(artworks[i]);
        this.setState({
          artworks: newArray
        })
      }
    }
  }

  setOtherList() {
    let { currentArtwork, artworks } = this.state;
    let k = artworks.length;
    var newArray1 = this.state.artworks.slice();
    for (let i = k - 1; i >= 0; i--) {
      newArray1.unshift(artworks[i]);
      this.setState({
        artworks: newArray1
      })
      currentArtwork++;
    }
    this.setState({ currentArtwork });
  }

  componentWillReceiveProps(nextProps) {
    let { userPlaylist } = nextProps;

    const playlistIndex = parseInt(userPlaylist.length / 2);
    const currentPlaylist = userPlaylist ? userPlaylist[playlistIndex] : 0;
    let name = userPlaylist.map((item, id) => item.content ? item.content.name : item.name);
    this.state = {
      currentPlaylist,
      currentArtwork: currentPlaylist ? currentPlaylist.content ? parseInt(currentPlaylist.content.artworks.length / 2) : parseInt(currentPlaylist.artworks.length / 2) : 0,
      name,
      current: name ? parseInt(name.length / 2) : 0,
      playlistIndex,
      show: false,
      playlist: userPlaylist,
      artworks: currentPlaylist ? currentPlaylist.content ? currentPlaylist.content.artworks : currentPlaylist.artworks : [],
      showlist: false,
      transition: false
    }
    setTimeout(() => this.setOtherList(), 10);
  }

  handlePlaylist(e) {
    switch (e.which) {
      case 37:
        this.prevList();
        break;
      case 39:
        this.nextList();
        break;
    }
  }

  nextList() {
    this.offset++;
    this.setState({
      transition: true
    })
    let { current, playlist } = this.state;
    this.rotate(playlist);
    this.selectTab(current);
  }

  prevList() {
    this.offset--;
    this.setState({
      transition: true
    })
    let { current, playlist } = this.state;
    this.rotateReverse(playlist);
    this.selectTab(current);
  }

  rotate(array) {
    var temp = array.shift();
    array.push(temp)
    this.setState({
      playlist: array,
      name: array.map((item, id) => item.content ? item.content.name : item.name),
    })
  }

  rotateReverse(array) {
    var temp = array.pop();
    array.unshift(temp)
    this.setState({
      playlist: array,
      name: array.map((item, id) => item.content ? item.content.name : item.name),
    })
  }

  selectTab(id) {
    const playlist = this.state.playlist[id];
    const art = playlist.content ? parseInt(playlist.content.artworks.length / 2) : parseInt(playlist.artworks.length / 2);

    this.setState({
      current: id,
      currentPlaylist: playlist,
      currentArtwork: art,
      playlistIndex: id,
      artworks: playlist.content ? playlist.content.artworks : playlist.artworks
    })

    setTimeout(() => this.setOtherList(), 10);
  }

  handleKeyDown(e) {
    switch (e.which) {
      case 13:
        sendIndexes(this.state.current, this.state.artworks[this.state.currentArtwork].id, this.offset, this.state.highquality, this.state.mute);
        this.props.history.push('/home');
        break;
      case 37:
        this.prev();
        break;
      case 39:
        this.next();
        break;
    }
  }

  next() {
    this.setState({
      transition: false,
      artNo: 3
    })
    let { currentArtwork, artworks } = this.state;
    currentArtwork += 1;
    if (currentArtwork == artworks.length - 3) {
      var newArray = this.state.artworks.slice();
      for (let i = 0; i < artworks.length; i++) {
        newArray.push(artworks[i]);
        this.setState({
          artworks: newArray
        })
      }
    }
    this.setState({ currentArtwork });
  }

  prev() {
    this.setState({
      transition: false,
      artNo: 2
    })
    let { currentArtwork, artworks } = this.state;
    currentArtwork -= 1;
    let k = artworks.length;
    if (currentArtwork == 2 || currentArtwork == 1) {
      this.setState({
        transition: true
      })
      var newArray = this.state.artworks.slice();
      for (let i = k - 1; i >= 0; i--) {
        newArray.unshift(artworks[i]);
        this.setState({
          artworks: newArray
        })
        currentArtwork++;
      }
      this.setState({
        transition: false
      })
    }

    this.setState({ currentArtwork });
  }

  render() {
    const { currentArtwork, currentPlaylist, artworks, artNo, current } = this.state;
    if (!artworks) {
      return null
    }
    let left = (- currentArtwork * 25) + 12.5;
    const slides = artworks.map((item, idx) => {
      left += 25;
      return (
        <div key="idx" className={this.state.transition ? idx == currentArtwork && this.state.show ? "home-playlists-carousel__body__playlist__slideFocus" : "home-playlists-carousel__body__playlist__slideNoTransition" : idx == currentArtwork && this.state.show ? "home-playlists-carousel__body__playlist__slideFocus" : "home-playlists-carousel__body__playlist__slide"} style={{ left: `${left}%` }}>
          <PlaylistArtwork key={idx} showImage={artNo == 2 ? idx >= currentArtwork - 2 && idx <= currentArtwork + 3 : idx >= currentArtwork - 3 && idx <= currentArtwork + 3} showDetails={idx == currentArtwork && this.state.show} artwork={item} />
        </div>
      );
    });

    let size = 100; //any random value
    let y = 0;
    let left1 = (- current * 17) + 24.5;
    const nameslides = this.state.name.map((item, idx, array) => {
      size < 9 ?
        idx == parseInt(this.state.current) + 2 || idx == parseInt(this.state.current) + 3 ? left1 += 12 : left1 += 17 :
        left1 += 17;
      size = item.length;
      if (y == 1) {
        left1 -= 5;
        y = 0;
      }
      if ((idx == parseInt(this.state.current) - 2 || idx == parseInt(this.state.current) - 3) && (array[idx + 1].length < 9) || (idx == parseInt(this.state.current) - 3 && array[idx + 2].length < 9)) {
        left1 += 5;
        y = 1;
      }

      return (
        <div key="idx" style={{ left: `${left1}%` }} className={idx == this.state.current ? this.state.showlist ? `home-playlists-carousel__header__playlist-title__select isSelected` : `home-playlists-carousel__header__playlist-title__select` : idx < this.state.current ? idx == this.state.current - 1 ? `home-playlists-carousel__header__playlist-title__one less` : idx == this.state.current - 2 ? `home-playlists-carousel__header__playlist-title__two less` : `home-playlists-carousel__header__playlist-title__three less` : idx == parseInt(this.state.current) + 1 ? `home-playlists-carousel__header__playlist-title__one more` : idx == parseInt(this.state.current) + 2 ? `home-playlists-carousel__header__playlist-title__two more` : `home-playlists-carousel__header__playlist-title__three more`}>
          {item}
        </div>
      );
    });

    return (
      <div
        className="home-playlists-carousel"
      >
        <div className="full-size">
          <div
            className="home-playlists-carousel__header"
            tabIndex="3"
            onKeyDown={this.handlePlaylist}
            onFocus={() => this.setState({ showlist: true })}
            onBlur={() => this.setState({ showlist: false })}
          >
            {nameslides}
          </div>
          <div className="home-playlists-carousel__body">
            <div
              tabIndex="4"
              className="home-playlists-carousel__body__playlist"
              onKeyDown={this.handleKeyDown}
              onFocus={() => this.setState({ show: true })}
              onBlur={() => this.setState({ show: false })}
            >
              {slides}
            </div>
          </div>
        </div>
      </div>
    )
  }
}